export { default } from './MainSidebar'


// WEBPACK FOOTER //
// ./src/components/Sidebar/MainSidebar/index.js